<template>
    <div class="articleSettingBox">
        <ul class="settingUl">
            <li>
                <span>图片</span>
                <el-switch v-model="data.imgValue">
                </el-switch>
            </li>
            <li>
                <span>浏览量</span>
                <el-switch v-model="data.browseValue">
                </el-switch>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'articleDeitelSetting',
  props: {
    data: Object
  },
  data () {
    return {

    }
  },
  methods: {
    querySearch (queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    handleSelect (item) {
      console.log(item)
    }
  }
}
</script>

<style scoped>
.articleSettingBox {
    padding: 0 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/article/articleDeitelSetting.vue